export default __webpack_public_path__ + "static/media/suporte.f3fdce20.png";